import React from 'react'
import PropTypes from 'prop-types'
import FormFieldError from '../FormFieldError'
import classnames from 'classnames'

const Text = ({
  input,
  inputClassName,
  label,
  meta,
  name,
  placeholder,
  subText,
  type,
  valid,
  ...rest
}) => (
  <div>
    <div className={`form-group ${meta.invalid ? 'is-invalid' : ''}`}>
      {label && <label htmlFor={input.name}>{label}</label>}
      <input
        autoComplete="off"
        className={classnames(
          `form-control`,
          {
            'is-invalid': meta.touched && meta.error,
          },
          inputClassName,
        )}
        disabled={meta.submitting}
        name={name || input.name}
        maxLength={1000}
        placeholder={placeholder}
        type={type}
        {...rest}
        {...input}
      />

      {subText && <small className="form-text text-muted">{subText}</small>}

      <FormFieldError {...meta} />
    </div>
  </div>
)

Text.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  input: PropTypes.object, // passed from react-final-form or redux-form
  inputClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]),
  meta: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  subText: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType, PropTypes.node]),
  type: PropTypes.string,
  valid: PropTypes.bool,
}
Text.defaultProps = {
  input: {},
  inputClassName: '',
  label: '',
  meta: {},
  name: '',
  placeholder: '',
  subText: '',
  type: 'text',
  valid: false,
}

export default Text
